module.exports = __webpack_public_path__ + "img/about3.683323a9.png";